export const RATE_LIST_REQUEST = "RATE_LIST_REQUEST";
export const RATE_LIST_SUCCESS = "RATE_LIST_SUCCESS";
export const RATE_LIST_FAIL = "RATE_LIST_FAIL";

export const RATE_LATEST_REQUEST = 'RATE_LATEST_REQUEST';
export const RATE_LATEST_SUCCESS = 'RATE_LATEST_SUCCESS';
export const RATE_LATEST_FAIL = 'RATE_LATEST_FAIL';